import { Link } from 'react-router-dom';
import { formatDateRange, formatGuests } from '../../utils/bookingUtils';

const StayCard = ({ stay, checkIn, checkOut, nights, guests, roomType, roomCount = 1, editLink = '' }) => {
  if (!stay) {
    return (
      <div className="rounded-2xl border border-dashed border-slate-200 bg-white/70 p-5 text-sm text-slate-500">
        Stay details will appear once a selection is made.
      </div>
    );
  }

  const image =
    stay.coverImage ||
    stay.featured_image ||
    stay.image_url ||
    'https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=900&q=80';

  return (
    <div className="rounded-2xl border border-[#E7DED4] bg-white p-5 shadow-[0_14px_34px_rgba(15,23,42,0.08)]">
      <div className="flex flex-col gap-4 sm:flex-row">
        <div className="relative h-44 w-full overflow-hidden rounded-xl sm:h-32 sm:w-44">
          <img src={image} alt={stay.title || stay.name || 'Stay'} className="h-full w-full object-cover" />
        </div>
        <div className="flex flex-1 flex-col gap-2">
          <div>
            <p className="text-xs uppercase tracking-[0.22em] text-slate-500">Your stay</p>
            <h3 className="text-xl font-semibold text-slate-900">{stay.title || stay.name || 'Homevilas stay'}</h3>
            <p className="text-sm text-slate-600">{[stay.city, stay.area].filter(Boolean).join(', ') || stay.location}</p>
          </div>
          <div className="text-sm text-slate-700">
            {formatDateRange(checkIn, checkOut)} | {nights || 0} nights | {formatGuests(guests)}
          </div>
          {(roomType?.name || roomCount > 1) && (
            <div className="text-sm text-slate-600">
              {roomType?.name ? roomType.name : 'Room selection'} · {roomCount} room{roomCount === 1 ? '' : 's'}
            </div>
          )}
          {editLink && (
            <Link to={editLink} className="text-sm font-semibold text-[#B56A2B] hover:text-[#8F4F1D]">
              Edit dates or guests
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default StayCard;
